import { render, staticRenderFns } from "./ServiceDetailCard.vue?vue&type=template&id=1a480265"
import script from "./ServiceDetailCard.vue?vue&type=script&lang=js"
export * from "./ServiceDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetailCard.vue?vue&type=style&index=0&id=1a480265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports